import state from './state'

const movementTypeName = function() {
    if(state.movement === 'apertura') return null

    let arrayTypes = null

    if(state.movement === 'ingreso'){
        arrayTypes = state.arrayIngressType
        console.log('INGRESS GETTER')
    }else if(state.movement === 'egreso'){ // 'egreso'
        arrayTypes = state.arrayEgressType
        console.log('EGRESS GETTER')
    }else{
        return null
    }

    for(let i = 0; i < arrayTypes.length; i++){
        if(arrayTypes[i].id === state.movementType){
            return arrayTypes[i].type
        }
    }

    return null
    
}

export default{
    movementTypeName,
}